import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Box, Card, CardContent, Link, Stack, Typography } from '@mui/material';

export function ErrorPage() {
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get('error') ?? 'unknown_error';
  const errorDescription =
    searchParams.get('error_description') ??
    'An unexpected authentication error occurred. Please try signing in again.';

  return (
    <Box sx={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}>
      <Card sx={{ width: '100%', maxWidth: 520 }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h5" component="h1" fontWeight={700}>
              Authentication error
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Error code: {errorCode}
            </Typography>
            <Typography variant="body1">{errorDescription}</Typography>
            <Link component={RouterLink} to="/auth/signin" underline="hover">
              Return to sign in
            </Link>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
